import { FC } from 'react';
import { Button, ButtonPrimary, Modal, ModalActions, ModalHeader, ModalProps } from '@lambdacurry/component-library';
import { MedusaProductVariant, SaveNeverPreferenceInput } from 'lib/home/generated/types/api';

export interface NeverConfirmationModalProps extends ModalProps {
  meal?: MedusaProductVariant;
  setNeverModal: (props: { meal: MedusaProductVariant | null; isOpen: boolean }) => void;
  saveNeverPreference: (props: SaveNeverPreferenceInput) => void;
}

export const NeverConfirmationModal: FC<NeverConfirmationModalProps> = ({
  isOpen,
  meal,
  setNeverModal,
  saveNeverPreference,
  ...props
}) => {
  return (
    <Modal isOpen={isOpen} {...props}>
      {meal ? (
        <>
          <ModalHeader title={meal.product.title} />

          <p>
            Are you sure you wish place this item in the never category? You will no longer see it on the regular
            selections
          </p>

          <ModalActions>
            <Button onClick={() => setNeverModal({ meal: null, isOpen: false })} data-cy="cancel">
              Cancel
            </Button>
            <ButtonPrimary
              type="submit"
              onClick={() => saveNeverPreference({ product_variant_id: meal.id, never: true })}
              data-cy="submit"
            >
              Add to Never Category
            </ButtonPrimary>
          </ModalActions>
        </>
      ) : (
        `There is no meal...`
      )}
    </Modal>
  );
};
